import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { activeUserAtom } from "../../../atoms/user/activeUserAtom";
import { QUERY_KEYS } from "../../../constants/queryKeys";
import { fetchReleaseTrackById } from "../releaseAPI";

export const useFetchReleaseTrackQuery = (releaseTrackId = 0) => {
  const slimUser = useAtomValue(activeUserAtom);
  return useQuery({
    enabled: Boolean(releaseTrackId),
    queryKey: [
      QUERY_KEYS.FETCH_RELEASE_TRACK_BY_ID,
      releaseTrackId,
      slimUser?.id,
    ],
    queryFn: async () => {
      return await fetchReleaseTrackById(releaseTrackId);
    },
  });
};
